export const hostBackgroundStyles = (backgroundImageUrl?: string, primaryColor?: string | null) => ({
	root: {
		position: 'absolute',
		top: 0,
		left: 0,
		height: '100%',
		width: '100%',
	},
	backgroundImage: {
		position: 'absolute',
		top: 0,
		left: 0,
		background: backgroundImageUrl ? `url(${backgroundImageUrl})` : 'none',
		height: '100%',
		width: '100%',
		backgroundSize: 'cover',
		backgroundPosition: 'center 45%',
		opacity: 0.05,
	},
	backgroundColor: {
		position: 'absolute',
		top: { xs: '-100px', md: '-525px' },
		left: '50%',
		transform: 'translateX(-50%)',
		width: { xs: '100%', md: 'calc(100% - 250px)' },
		height: { xs: '550px', md: '725px' },
		borderRadius: { xs: 0, md: '20%' },
		filter: { xs: 'blur(120px)', md: 'blur(100px)' },

		background: `linear-gradient(-90deg, ${primaryColor} 0%, ${primaryColor}4D 100%)`,
		transition: 'background 0.5s ease-in',
	},
});
